import { Link } from "react-router-dom";
import { useStore } from "@/hooks/useStore";
import { Panel, PageTitle } from "@/components/ui/Panel";
import { Button } from "@/components/ui/Button";
import { Badge } from "@/components/ui/Badge";
import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { toast } from "sonner";

export function Decks() {
  const { state, setState } = useStore();
  const [pubs, setPubs] = useState<Record<string, boolean>>({});

  useEffect(() => {
    supabase.from("deck_publish").select("deck_id, published").then(({ data }) => {
      const m: Record<string, boolean> = {};
      (data ?? []).forEach((r: any) => { m[r.deck_id] = r.published; });
      setPubs(m);
    });
  }, []);

  async function togglePublish(id: string) {
    const next = !pubs[id];
    setPubs((p) => ({ ...p, [id]: next }));
    const { error } = await supabase.from("deck_publish").upsert({
      deck_id: id, published: next, updated_at: new Date().toISOString(),
    }, { onConflict: "deck_id" });
    if (error) toast.error(error.message);
    else toast.success(next ? "Deck published" : "Deck unpublished");
  }

  function remove(id: string) {
    if (!confirm("Delete deck?")) return;
    setState((s) => ({ ...s, decks: s.decks.filter((d) => d.id !== id) }));
    toast.success("Deck deleted");
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <PageTitle>Decks ({state.decks.length})</PageTitle>
        <Link to="/decks/new"><Button>+ New deck</Button></Link>
      </div>
      {state.decks.length === 0 ? (
        <Panel><p className="text-sm text-[#64748b]">No decks yet.</p></Panel>
      ) : (
        <div className="grid gap-3">
          {state.decks.map((d) => (
            <Panel key={d.id} className="flex items-center justify-between gap-4">
              <div>
                <p className="font-display text-base font-semibold">{d.deckName}</p>
                <p className="text-xs text-[#64748b]">
                  {d.mainDeck.reduce((a, e) => a + e.count, 0)} cards · {d.signatureMoveIds.length} sigs · {d.equipmentIds.length} equipment
                </p>
                <div className="mt-1 flex gap-1.5">
                  <Badge tone={d.legality.status === "legal" ? "green" : "red"}>{d.legality.status}</Badge>
                  {pubs[d.id] && <Badge tone="amber">published</Badge>}
                </div>
              </div>
              <div className="flex gap-2">
                <Button variant="secondary" onClick={() => togglePublish(d.id)}>
                  {pubs[d.id] ? "Unpublish" : "Publish"}
                </Button>
                <Link to={`/decks/${d.id}/edit`}><Button variant="secondary">Edit</Button></Link>
                <Button variant="danger" onClick={() => remove(d.id)}>Delete</Button>
              </div>
            </Panel>
          ))}
        </div>
      )}
    </div>
  );
}
